import { createAsyncThunk } from '@reduxjs/toolkit';
import { stringifyUrl } from 'query-string';

import { tokensApi } from '@/services/api';
import { CLIENT_ID } from '@/constants/auth';
import { auth } from '@/constants';
import { RevokeRequest, LogoutRequest } from '@/types/openid';
import { RootState } from '..';

// MEMO: private actionで使わないように注意
export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const accessToken = state.auth.session?.token;
    try {
      if (accessToken) {
        const revokeParams: RevokeRequest = {
          client_id: CLIENT_ID,
          token: accessToken,
        };
        await tokensApi.revoke(revokeParams);
      }
      return;
    } catch (err) {
      return rejectWithValue({ err });
    } finally {
      const logoutParams: LogoutRequest = {
        client_id: CLIENT_ID,
        post_logout_redirect_uri: auth.Url.logoutRedirectUri,
        type: 'admin',
      };
      const logoutUri = stringifyUrl({
        url: auth.Url.logoutUri,
        query: logoutParams,
      });

      window.location.assign(logoutUri);
    }
  },
);
